import header from '~/mixins/header.js'
import modalSignup from '~/mixins/modalSignup.js'
import debounce from 'lodash.debounce'
import supersonicTopStripe from '~/components/Supersonic/TopStripe/TopStripe.vue'
import hotOrganicTopStripe from '~/components/Molecules/Organic/TopStripe/TopStripe.vue'
import hotSubMenu from '~/components/Molecules/Organic/SubMenu/SubMenu.vue'
import hotIcon from '~/components/Atoms/Icon/Icon.vue'
import signupButton from '~/components/Molecules/OrganicSquad/SignupButton/SignupButton.vue'
import device from '~/mixins/device.js'

export default {
  mixins: [device, modalSignup, header],

  components: {
    supersonicTopStripe,
    signupButton,
    hotOrganicTopStripe,
    hotSubMenu,
    hotIcon,
  },

  props: {
    supersonicHeader: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      canShowTopStripe: true,
      expLoginHeader: '0',
      hasTop: true,
      scrollY: 0,
    }
  },

  mounted() {
    window.addEventListener('scroll', this.handleScroll, { passive: true })
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll)
  },

  computed: {
    hasLogoLabel() {
      return !!this.navigation?.logo?.label
    },
    isFixed() {
      return this.scrollY > 50 && this.scrollY <= 100
    },
    isHidden() {
      return this.scrollY > 100
    },

    hasNotificationBar() {
      return this.navigation.notificationBar ? true : false
    },

    isCheckedLocaleAbTest() {
      return ['pt-br', 'es-es', 'es-co', 'es-mx'].includes(this.$i18n.locale)
    },

    isCampaign() {
      return Boolean(
        ['pt-br'].includes(this.$i18n.locale) &&
          (!this.$route.query.v || !['a', 'b', 'c'].includes(this.$route.query.v))
      )
    },

    isTest() {
      return Boolean(['pt-br'].includes(this.$i18n.locale) && this.$route.query.v === 'b')
    },

    stripeContent() {
      return this.isCampaign
        ? this.$t('components.topStripe.campaign')
        : this.isTest
        ? this.$t('components.topStripe.test')
        : this.$t('components.topStripe.default')
    },

    isSSOTestAB() {
      const test = this.$route.query['test']

      return Boolean(['pt-br'].includes(this.$i18n.locale) && test === 'os_sso')
    },

    hasLogoClass() {
      return this.navigation.logo.class ? this.navigation.logo.class : 'normal'
    },

    isHomepage() {
      return Boolean(this.$route.name && this.$route.name.includes('index'))
    },

    hasTopStripe() {
      return Boolean(this.topStripe)
    },

    isInverted() {
      return false
    },

    isMobileCta() {
      return !this.isDesktop && this.$i18n.locale === 'pt-br'
        ? 'Cadastre-se grátis'
        : this.navigation.plattaform.signUp.label
    },
  },

  methods: {
    isAnchor(href) {
      return /^(https?:\/\/|\/\/)/.test(href) && /#[\w-]+/.test(href)
    },

    scroll(e) {
      this.scrollDebounce(e, this)
    },

    scrollDebounce: debounce((e, self) => {
      const { y: currentScrollPositionY } = self.scrollPosition()

      if (self.isScrollDown() && self.isOutsideSafetyMarginHeader()) {
        self.unpinned = false
        self.solid = true

        if (self.headerDetached()) self.hasTop = false
        else self.hasTop = false
      }

      if (self.isScrollUp()) {
        self.unpinned = false
        if (self.isOutsideSafetyMarginHeader()) self.solid = true
        else self.solid = false

        if (self.headerDetached()) self.hasTop = false
        else self.hasTop = false
      }

      self.previousScrollPositionY = currentScrollPositionY
    }, 16),

    scrollPosition() {
      let scrollPositionY = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      const scrollMinY = 0
      const scrollMaxY =
        window.scrollMaxY || document.getElementById('__layout').scrollHeight - document.documentElement.clientHeight

      if (scrollPositionY < scrollMinY) scrollPositionY = scrollMinY
      if (scrollPositionY > scrollMaxY) scrollPositionY = scrollMaxY

      return {
        y: scrollPositionY,
      }
    },

    headerDetached() {
      const { y: currentScrollPositionY } = this.scrollPosition()

      return Boolean(currentScrollPositionY > 50)
    },

    isScrollDown() {
      const { y: currentScrollPositionY } = this.scrollPosition()
      const isScrollDown = this.previousScrollPositionY < currentScrollPositionY

      return isScrollDown
    },

    isScrollUp() {
      return !this.isScrollDown()
    },

    isOutsideSafetyMarginHeader() {
      const { height: headerHeight } = this.header.getBoundingClientRect()
      const { top: pageOffsetTop } = this.page.getBoundingClientRect()
      const headerSafetyMargin = headerHeight / 2

      return headerSafetyMargin < -pageOffsetTop
    },

    handleScroll() {
      this.scrollY = window.pageYOffset
    },
    closeTopStripe() {
      this.canShowTopStripe = false
    },
  },
}
